import $ from 'jquery'

let $document = $(document)

// Toggle
$document.on('click', '.push-toggle', function(e) {
    let $el     = $(this)
    $el         = $el.is('a') ? $el : $el.find('a')
    let $target = $document.find($el.attr('href'))
    
    if ($target.length) {
        let $toggles = $(`.push-toggle[href="${$el.attr('href')}"]`)
        
        $target.toggleClass('active')
        $toggles.toggleClass('active', $target.hasClass('active'))
        
        e.preventDefault()
    }
})